import { render } from "./balancereport.vue?vue&type=template&id=5b423a1a"
import script from "./balancereport.vue?vue&type=script&lang=js"
export * from "./balancereport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__